import React from 'react';
import { Icon } from './Icon.js';
export const IconGripDotsFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("circle", { cx: "9", cy: "6.75", r: "1.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "14.25", cy: "6.75", r: "1.25", fill: "currentColor" }),
        React.createElement("circle", { cx: "3.75", cy: "6.75", r: "1.25", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "11.25", r: "1.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "14.25", cy: "11.25", r: "1.25", fill: "currentColor" }),
        React.createElement("circle", { cx: "3.75", cy: "11.25", r: "1.25", fill: "currentColor" })));
};
//# sourceMappingURL=IconGripDotsFill18.js.map